import { Component, Output, EventEmitter, Input } from '@angular/core';

import { DataManager } from 'techlify-ng';
import { AlertService } from 'techlify-ng';
import { RequestErrorService } from 'techlify-ng';

import { AutoDealerInformation } from "./auto-dealer-information.model";
import { Client } from '../client/client.model';

/**
 * Controller that adds a new record
 * 
 * @author Floyd Kissoon
 * @since 20190815
 */
@Component({
    selector: 'auto-dealer-information-add',
    templateUrl: './auto-dealer-information-form.html'
})
export class AutoDealerInformationAddComponent {
    @Input() client: Client;
    @Output() onSave = new EventEmitter<AutoDealerInformation>();
    private autoDealerInfo: AutoDealerInformation;

    private isWorking = false;

    constructor(private dataManager: DataManager,
        private alertService: AlertService,
        private errorHandler: RequestErrorService) { }

    initForm() {
        this.autoDealerInfo = new AutoDealerInformation();
        this.autoDealerInfo.client_id = this.client.id;
    }

    ngOnInit() {
        this.initForm();
    }

    save() {
        this.isWorking = true;
        this.autoDealerInfo.client_id = this.client.id;
        this.dataManager.POST('api/auto-dealer-information', this.autoDealerInfo).then(
            res => {
                this.onSave.emit(res.item);
                this.alertService.addAlert('Successfully added Auto Dealer information', 'success');
                this.isWorking = false;
                this.initForm();
            },
            error => {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}